import Blue from "~/core";

new Blue({
	name: 'Drawer',
	selector: ".drawer",
	setup(drawer) {
		const _this = this;
		const header = document.querySelector('.header');
    const trigger = drawer.querySelector('.drawer__trigger');
		const headerTrigger = document.querySelector('.toggle__drawer');
		const links = drawer.querySelectorAll('a[href]');
		let name = drawer.dataset.name;
		let expire = parseInt(drawer.dataset.expire);
		let dismissed = `${name}_Scroll--dismissed`;

		links.forEach(link => {
			this.$addEvents(link, 'click', () => {
				drawer.classList.remove('is-open');
				this.$scrollLock.unlock(drawer);
			});
		});

		const detectScroll = (() => {
			let isScrolling = false;
			return function() {
				if(!isScrolling && window.pageYOffset > 200) {
					_this.$setCookie(dismissed, true, expire);
					_this.$scrollLock.lock(drawer);
					isScrolling = true;
					drawer.classList.add('is-open');
				}
 			}
		})();

		this.$addEvents(document, 'scroll', () => {
			if(!this.$getCookie(dismissed)) {
				detectScroll();
			}
		});
		
		this.$addEvents(window, 'DOMContentLoaded', () => {
			if(window.location.hash == '#specials') {
				drawer.classList.toggle('is-open');
				if(header.classList.contains('is-open')) {
					header.classList.remove('is-open');
					this.$scrollLock.unlock(header);
				}
				if(!drawer.classList.contains('is-open')) {
					this.$scrollLock.unlock(drawer);
				} else {
					this.$scrollLock.lock(drawer);
				}
			}
		});

		this.$addEvents([trigger, headerTrigger], 'click', () => {
			drawer.classList.toggle('is-open');
			if(header.classList.contains('is-open')) {
				header.classList.remove('is-open');
				this.$scrollLock.unlock(header);
			}
			if(!drawer.classList.contains('is-open')) {
				this.$scrollLock.unlock(drawer);
			} else {
				this.$scrollLock.lock(drawer);
			}
		});
	}
});